import { themeTypes } from "@/src/constants/themeConstants.js";

export function getThemeIcon(option, theme) {
  if (!option) {
    console.warn("getThemeIcon called with undefined option");
    return "";
  }

  const isLight =
    theme === themeTypes.LIGHT ||
    (theme === themeTypes.AUTO &&
      !window.matchMedia("(prefers-color-scheme: dark)").matches);

  if (option.icon) {
    return isLight && option.lightIcon ? option.lightIcon : option.icon;
  }
}
